const articleTypes = [
    {
        uid: '0',
        translations: {
            deu: 'definitiv'
        }
    },
    {
        uid: '1',
        translations: {
            deu: 'indefinitiv'
        }
    },
    {
        uid: '2',
        translations: {
            deu: 'ohne'
        }
    },
    {
        uid: '3',
        translations: {
            deu: 'possesiv pronomen'
        }
    }
];

export default articleTypes;